import React from 'react';
import PropTypes from 'prop-types';

import { Container } from './styles';

const Props = {
  name: PropTypes.string.isRequired,
};

export default function Icon({ name }) {
  return <Container>{name}</Container>;
}

Icon.propTypes = Props;
